import React, { useCallback } from "react";
import cn from "classnames";

import styles from "./style.module.scss";

interface ButtonProps {
  className?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >["type"];
}

const Button: React.FC<ButtonProps> = props => {
  const { onClick, isDisabled, children, className, type, isLoading } = props;
  const onButtonClicked = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (isLoading) {
        return;
      }
      if (onClick) {
        onClick(e);
      }
    },
    [isLoading, onClick]
  );
  return (
    <button
      type={type}
      className={cn(styles.button, className, {
        [styles.loading]: isLoading,
        [styles.defaultButton]: className == null,
      })}
      onClick={onButtonClicked}
      disabled={isDisabled}
    >
      {!isLoading && children}
    </button>
  );
};

export default Button;
